<template>
  <v-container fill-height fluid justify-center>
    <v-card tile>
      <v-card-title>
        <v-toolbar-title>Forget Password</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="update">OK</v-btn>
        <!-- <v-btn @click="turnBack">{{$t('app.buttons.back')}}</v-btn> -->
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <div required>
                <v-text-field
                  :rules="[
                    (v) =>
                      /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%+=_\-^&*?]).*$/.test(
                        v
                      ) ||
                      `パスワードの書式  最小8桁、最大16桁まで、少なくとも一つの大文字、小文字、数字と特殊記号を含む必要があります。`,
                    (v) =>
                      /^[^\s]*$/.test(v) ||
                      'パスワードにはスペースが入ってはいけません。',
                  ]"
                  label="New Password"
                  type="password"
                  v-model="newPassword"
                />
              </div>
            </v-flex>
            <v-flex xs12>
              <div required>
                <v-text-field
                  :rules="[
                    (v) => !!v || `Password Again is required`,
                    (v) => v == this.newPassword || `Password must match`,
                  ]"
                  label="Password Again"
                  type="password"
                  v-model="againPassword"
                />
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import md5 from "md5";
import { mapGetters } from "vuex";
import { Encrypt } from "../../service/Encrypt";

export default {
  data() {
    return {
      user_account_id: null,
      show: false,
      valid: false,
      newPassword: null,
      againPassword: null,
      force: null,
      firstEnter: null,
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    turnBack() {
      this.$router.push();
    },
    popup(force) {
      this.force = force;
      this.show = true;
    },
    update() {
      return this.$http
        .put(`/auth-service/auth/admin-update-password`, {
          userId: this.user_account_id,
          newPassword: Encrypt(this.newPassword),
        })
        .then((res) => {
          return this.$http
            .get(
              "/employees/change-date?userAccountId=" + this.user_account_id,
              {
                headers: {
                  jumpAuth: true,
                },
              }
            )
            .then((r) => {
              if (res.data.success) {
                this.$message(
                  "",
                  "パスワードのリセットに成功しました",
                  "SUCCESS"
                );
                this.show = false;
                this.logoff();
              } else {
                this.$showApiError(res);
                this.logoff();
              }
            });
        })
        .catch(() => {
          this.$message("", "パスワードのリセットに失敗しました", "ERROR");
        });
    },
    logoff() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      localStorage.removeItem("currentEmployee");
      this.$store.dispatch("LOGOUT");
      this.$router.push("B0100");
    },
  },
  mounted() {
    this.user_account_id = this.$route.query.userAccountId;
    return this.$http
      .get(
        "/employees/get-reset-info?id=" +
          this.$route.query.UUID +
          "&token=" +
          this.$route.query.token,
        {
          headers: {
            jumpAuth: true,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        this.user_account_id = res.data.replace("USER_ACCOUNT_ID", "");
      })
      .catch((res) => {
        if (res.response.data.message === "INVALID_TOKEN") {
          this.$message("", "無効リンク");
          this.logoff();
        } else if (res.response.data.message === "OVER_TIME") {
          this.$message("", "リンクが無効になりました。");
          this.logoff();
        } else if (res.response.data.message === "INVALID_HISTORY") {
          this.$message("", "リンクが無効になりました。");
          this.logoff();
        }
      });
  },
};
</script>
